import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

function Metatags({ meta, locale }) {
  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      {meta?.metaTitle && <title>{meta.metaTitle}</title>}

      {meta?.metaDescription && (
        <meta name="description" content={meta.metaDescription} />
      )}
      <meta name="twitter:card" content="summary" />
      {meta?.ogTitle && <meta property="og:title" content={meta.ogTitle} />}
      {meta?.ogDescription && (
        <meta property="og:description" content={meta.ogDescription} />
      )}
      {meta?.ogImage && <meta property="og:image" content={meta.ogImage} />}
      {meta?.canonical && <link rel="canonical" href={meta.canonical} />}
      {meta?.noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

Metatags.propTypes = {
  meta: PropTypes.object,
  locale: PropTypes.string,
}

Metatags.defaultProps = {
  locale: 'de',
}

export default Metatags
